export class UserProductConfigModel {
    UserId: string;
    OwnerCode: string;
    ProductCode: string;
    IsGrnNoActive: boolean = true;
    IsPackIdActive: boolean = true;
    IsSerialNoActive: boolean = true;
    IsLotNoActive: boolean = true;
    IsProductionDateActive: boolean = true;
    IsExpiryDateActive: boolean = true;
    IsOptField1Active: boolean = true;
    IsOptField2Active: boolean = true;
    IsOptField3Active: boolean = true;
    IsOptField4Active: boolean = true;
    IsOptField5Active: boolean = true;
    IsOptField6Active: boolean = true;
    IsOptField7Active: boolean = true;
    IsOptField8Active: boolean = true;
    IsOptIntField1Active: boolean = true;
    IsOptIntField2Active: boolean = true;
    IsOptIntField3Active: boolean = true;
    IsOptIntField4Active: boolean = true;
    IsOptDecField1Active: boolean = true;
    IsOptDecField2Active: boolean = true;
    IsOptDateField1Active: boolean = true;
    IsOptDateField2Active: boolean = true;
    PalletCount: boolean = true;
    IsGrnDateActive: boolean = true;
    IsStorageCategoryActive: boolean = true;

    IsGrnNoEditable: boolean;
    IsPackIdEditable: boolean;
    IsSerialNoEditable: boolean;
    IsLotNoEditable: boolean;
    IsProductionDateEditable: boolean;
    IsExpiryDateEditable: boolean;
    IsOptField1Editable: boolean;
    IsOptField2Editable: boolean;
    IsOptField3Editable: boolean;
    IsOptField4Editable: boolean;
    IsOptField5Editable: boolean;
    IsOptField6Editable: boolean;
    IsOptField7Editable: boolean;
    IsOptField8Editable: boolean;
    IsOptIntField1Editable: boolean;
    IsOptIntField2Editable: boolean;
    IsOptIntField3Editable: boolean;
    IsOptIntField4Editable: boolean;
    IsOptDecField1Editable: boolean;
    IsOptDecField2Editable: boolean;
    IsOptDateField1Editable: boolean;
    IsOptDateField2Editable: boolean;
    IsGrnDateEditable: boolean;
    IsStorageCategoryEditable: boolean;

    CreatedBy: string;
    UpdatedBy: string;
}



// WEBPACK FOOTER //
// ./src/app/data/models/master/op/user-product-config.model.ts